import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import processEvent from './process-event';
import { FabricChannel } from '../types';
import GenericAnalyticsListener from '../GenericAnalyticsListener';
export default function LinkingPlatformAnalyticsListener(props) {
  return /*#__PURE__*/React.createElement(GenericAnalyticsListener, _extends({}, props, {
    channel: FabricChannel.linkingPlatform,
    processEvent: processEvent
  }));
}